import React from "react";
import clsx from "clsx";
import './SeericButton.css';

type ButtonVariant = "primary" | "secondary" | 'tertiary' | "danger" | "ghost"| "blackghost" | "modal-primary" | "modal-secondary";

interface SeericButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  className?: string;
}

export function SeericButton({
  children,
  variant = "primary",
  className = "",
  ...props
}: SeericButtonProps) {
  return (
    <button
      className={clsx(
        "seeric-btn-base",
        {
          "seeric-btn-primary": variant === "primary",
          "seeric-btn-secondary": variant === "secondary",
          "seeric-btn-tertiary": variant === "tertiary",
          "seeric-btn-danger": variant === "danger",
          "seeric-btn-ghost": variant === "ghost",
          "seeric-btn-blackghost": variant === "blackghost",
          "seeric-btn-modal-primary": variant === "modal-primary",
          "seeric-btn-modal-secondary": variant === "modal-secondary",
        },
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}